import PaymentsFieldLabel from "./PaymentsFieldLabel";

export default function PaymentsModalField({ className = "", label, renderValue }) {
  return (
    <div className={`flex w-full flex-col gap-1 ${className}`}>
      <PaymentsFieldLabel value={label} />
      {renderValue}
    </div>
  );
}
